var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Box, Optional, Row as DsRow } from '@honda-canada/design-system-react';
import ConfigurationProvider from './service/Provider';
import NavigationItem from './NavigationItem';
import themeStyles from './BrandNavigation.styles';
var Wrapper = themeStyles.apply(Box, 'Wrapper');
var Row = themeStyles.apply(DsRow, 'Row');
var Column = themeStyles.apply(Box, 'Column');
export var BrandNavigationUI = function (_a) {
    var _b, _c;
    var componentName = _a.componentName, fields = _a.fields;
    var lastItem = (_c = (_b = fields === null || fields === void 0 ? void 0 : fields.items) === null || _b === void 0 ? void 0 : _b.slice().reverse()) === null || _c === void 0 ? void 0 : _c[0];
    var rightSideLink = isEmpty(lastItem === null || lastItem === void 0 ? void 0 : lastItem.navImage) ? lastItem : false;
    var items = fields === null || fields === void 0 ? void 0 : fields.items.filter(function (item) { return item.itemId !== (rightSideLink === null || rightSideLink === void 0 ? void 0 : rightSideLink.itemId); });
    return (React.createElement(Wrapper, { "data-component-name": componentName, "data-testid": "cy-brand-navigation" },
        React.createElement(Row, null,
            React.createElement(Column, { mr: "auto" }, items.map(function (item) { return (React.createElement(NavigationItem, __assign({ key: item.itemId }, item))); })),
            React.createElement(Optional, { when: rightSideLink },
                React.createElement(Column, null,
                    React.createElement(NavigationItem, __assign({}, rightSideLink)))))));
};
var BrandNavigation = function (_a) {
    var appNameConfig = _a.appNameConfig, restProps = __rest(_a, ["appNameConfig"]);
    return (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
        React.createElement(BrandNavigationUI, __assign({}, restProps))));
};
export default BrandNavigation;
